import type { ReactNode } from 'react'
import { cn } from '@/shared/lib'

type Tone = 'tag' | 'accent' | 'neutral'

interface ChipProps {
  tone?: Tone
  className?: string
  children: ReactNode
}

const tones: Record<Tone, string> = {
  tag: 'bg-tag-bg text-tag-fg',
  accent: 'bg-accent text-accent-fg',
  neutral: 'bg-raise text-muted',
}

export function Chip({ tone = 'neutral', className, children }: ChipProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2.5 py-0.5 text-caption font-medium',
        tones[tone],
        className,
      )}
    >
      {children}
    </span>
  )
}
